export default "<div id=\"mapcontainer\" style=\"height: 500px; min-width: 310px; max-width: 800px; margin: 0 auto\"></div>";